import React, { useEffect, FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { Share } from 'src/components/share'

const style = require('./Widget.css')

declare var BASE_URL: string
const SCRIPT_ID = 'calendar-widget-script'

const loadCalendarWidget = (eventData, lang) => {
  if (window.document.body.querySelector(`#${SCRIPT_ID}`)) return

  const loadScript = document.createElement('script')
  loadScript.src = `${BASE_URL}/embed2.js`
  loadScript.id = SCRIPT_ID
  loadScript.setAttribute('data-widget-type', 'universe-calendar')
  loadScript.setAttribute('data-target-type', 'multi-time-slot')
  loadScript.setAttribute('data-target-id', eventData.user.id)

  loadScript.setAttribute('data-state', `lang=${lang}`)

  window.document.querySelector(`.${style.calendar}`).appendChild(loadScript)
}

interface Props {
  eventData: any,
  loading: Boolean,
  slug: Boolean,
  social: Boolean,
}

const WidgetComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  intl: { locale },
  loading,
  slug,
  social = false,
}) => {
  useEffect(() => {
    if (!SSR_DATA.prerendering) loadCalendarWidget(eventData, locale)
  }, [eventData, locale])

  return (
    <div className={style.container}>
      <div className={style.calendar} />
      <Share />
    </div>
  )
}

export const Widget = injectIntl(WidgetComponent)
